import React, { useContext, useState, useEffect } from "react";
import { Await, useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";
import FirmList from "./FirmList";
import { Link } from "react-router-dom";
import FirmSubUpdate from './FirmSubUpdate';
import ThemeContext from "../../context/ThemeContext";
import UserContext from '../../context/UserContext';

import YourComponent from '../../context/IdSeqContext';
import { useYourComponentContext } from '../../context/IdSeqContext2';
import MyCompm from '../../context/IdSeqContext3';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';


const GET_POST = gql`
query MyQuery($firmCode: String!) {
  tbl_firm_main(where: {firm_code: {_eq: $firmCode}}) {
    updated_at
    update_user
    place
    firm_type
    firm_name
    firm_code
    created_at
    create_user
    active
  }
  tbl_firm_sub(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    firm_sub_name
    firm_sub_type
    place
    update_user
    updated_at
    create_user
    created_at
    active
  }
  tbl_user_detail(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    user_name
    name
    user_type
  }
}
`;

const UPDATE_FIRM = gql`
  mutation UpdateFirm(
    $firmCode: String!
    $firmName: String!
    $firmType: String!
    $place: Int!
  ) {
    update_tbl_firm_main(
      where: { firm_code: { _eq: $firmCode } }
      _set: { firm_name: $firmName, firm_type: $firmType, place: $place }
    ) {
      affected_rows
    }
  }
`;

const INSERT_FIRM = gql`
  mutation InsertFirm(
    $firmCode: String!
    $firmName: String!
    $firmType: String!
    $place: Int!
    $active: Boolean!
    $createUser: String!
    $updateUser: String!
  ) {
    insert_tbl_firm_main(
      objects: {
        firm_code: $firmCode,
        firm_name: $firmName,
        firm_type: $firmType,
        place: $place,
        active: $active,
        create_user: $createUser,
        update_user: $updateUser,
        
      }
    ) {
      affected_rows
    }
  }
`;

const INSERT_SUB_FIRM = gql`
  mutation InsertSubFirm(
    $firmMainCode: String!
    $firmSubCode: String!
    $firmSubName: String!
    $firmSubType: String!
    $createSubUser: String!
    $updateSubUser: String!
   
    $active: Boolean!
  ) {
    insert_tbl_firm_sub(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        firm_sub_name: $firmSubName,
        firm_sub_type: $firmSubType,
        create_user: $createSubUser,
        update_user: $updateSubUser,
        
        active: $active
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_TEMP_RECORDS = gql`
  query GetTempRecords($tempType: String, $lang: String) {
    tbl_temp(where: { temp_type: { _eq: $tempType }, opt_1: { _eq: $lang } }) {
      temp_code
      temp_name
      temp_group
      temp_type
      opt_1
      opt_2
    }
  }
`;



const GET_TEMP_RECORDS2 = gql`
  query GetTempRecords($tempType2: String, $lang2: String) {
    tbl_temp(where: { temp_type: { _eq: $tempType2 }, opt_1: { _eq: $lang2 } }) {
      temp_code
      temp_name
      temp_group
      temp_type
      opt_1
      opt_2
    }
  }
`;

const INSERT_TEMP_RECORDS_MUTATION = gql`
  mutation InsertTempRecordsIntoDprMain($records: [tbl_dpr_main_insert_input!]!) {
    insert_tbl_dpr_main(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_TEMP_RECORDS_MUTATION2 = gql`
  mutation InsertTempRecordsIntoDprSub($records: [tbl_dpr_sub_insert_input!]!) {
    insert_tbl_dpr_sub(objects: $records) {
      affected_rows
    }
  }
`;

const GET_LANG_ITEMS = gql`
query GetLangItems($defType: String!) {
  tbl_gnl_defination(where: { type: {_eq: $defType } }) {
    code
    name
  }
}
`;

const GET_LANG_ITEMS2 = gql`
  query GetLangItem($defType: String!) {
    tbl_gnl_def(where: {type: {_eq: $defType}})  {
      code
      name
      type
    
    }
  }
`;
const GET_MDPR_ITEMS = gql`
  query GetMdprItemw($defType: String!) {
    tbl_gnl_def(where: {type: {_eq: $defType}})  {
      code
      name
      type
    
    }
  }
`;

const INSERT_LOGIN_USER = gql`
  mutation InsertLoginUser(
    $loginUserName: String!
    $loginUserPass: String!
    $createLoginUser: String!
    $updateLoginUser: String!

  ) {
    insert_tbl_login(
      objects: {
        user_name: $loginUserName,
        pass: $loginUserPass,
        create_user: $createLoginUser,
        update_user: $updateLoginUser,
        active: true,
      }
    ) {
      affected_rows
    }
  }
`;

const INSERT_DTL_USER = gql`
  mutation InsertDtlUser(
    $dtlUserFirmMainCode: String!
    $dtlUserFirmSubCode: String!   
    $dtlUserFirmType: String!
    
    $dtlLoginUserName: String!
    $dtlUserName: String!
    $dtlUserLastName: String!
    $dtlUserDprMainCode: String!
    $dtlUserDprSubCode: String!
    $dtlUserLang: String!
    $dtlUserDataLang: String!
    $createSubUser: String!
    $updateSubUser: String!
   
   
  ) {
    insert_tbl_user_detail(
      objects: {
        firm_main_code: $dtlUserFirmMainCode,
        firm_sub_code: $dtlUserFirmSubCode,       
        user_type: $dtlUserFirmType,

        user_name: $dtlLoginUserName,
        name: $dtlUserName,
        last_name: $dtlUserLastName,

        dpr_main_code: $dtlUserDprMainCode,
        dpr_sub_code: $dtlUserDprSubCode,
        user_lang: $dtlUserLang,
        data_lang: $dtlUserDataLang,


        create_user: $createSubUser,
        update_user: $updateSubUser,
        
        
      }
    ) {
      affected_rows
    }
  }
`;

const FirmCreateWizard = () => {
  const { firm_code } = useParams();
  const { loading, error, data } = useQuery(GET_POST, {
    variables: { firmCode: "-1" },
  });

  const [tempType, setTempType] = useState('');
  const [lang, setLang] = useState("en");
  const [tempType2, setTempType2] = useState('ASDPR');
  const [lang2, setLang2] = useState("en");
  const defType = 'LANG';
  
  


  

  const { loading: tempLoading, error: tempError, data: tempData } = useQuery(GET_TEMP_RECORDS, {
    variables: { tempType, lang },
  });

  const { loading: tempLoading2, error: tempError2, data: tempData2 } = useQuery(GET_TEMP_RECORDS2, {
    variables: { tempType2, lang2 },
  });

  

  const { loading: langLoading2, error: langError2, data: tempData3 } = useQuery(GET_LANG_ITEMS2, {
    variables: { defType },
  });

  

  const userSdprSelectItems = [
    {label: 'General Management(HTL)', value: 'HGMNG'},
    {label: 'IT Department(HTL)', value: 'HITD'},
    {label: 'IT Department(AGN)', value: 'ASIT'},
    
];

 
  const userMdprSelectItems = [
    {label: 'Management Department(HTL)', value: 'HMNG'},
    {label: 'Maintenance Department(HTL)', value: 'HMAI'},
    {label: 'Maintenance Department(AGN)', value: 'AMAI'},
    
];

const userLangSelectItems = [
  {label: 'English', value: 'en'},
  {label: 'Turkish', value: 'tr'},
  {label: 'Russian', value: 'ru'},
  {label: 'German', value: 'de'},
  {label: 'Spanish', value: 'es'},
  {label: 'Dutch', value: 'nl'},
  {label: 'Italian', value: 'it'},
  
  
  
];


/*const userLangSelectItems = tempData3.tbl_gnl_def.map((item) => ({
  label: item.name,
  value: item.code,
}));

if (langLoading2) return <p>Loading...</p>;
  if (langError2) return <p>Error: {error.message}</p>; */
 
 


  
  const items = [{ label: 'Dashboard' ,url: "/", target: '_self'}, { label: 'Definitions' }, { label: 'Firm Definitions' ,url:"/sterna/definitions/main" }, { label: 'Create Firm Wizard' }];
  
  const [insertTempRecords] = useMutation(INSERT_TEMP_RECORDS_MUTATION);
  const [insertTempRecords2] = useMutation(INSERT_TEMP_RECORDS_MUTATION2);

  
  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [InsertFirm] = useMutation(INSERT_FIRM);
  const [InsertSubFirm] = useMutation(INSERT_SUB_FIRM);

  const [InsertLoginUser] = useMutation(INSERT_LOGIN_USER);
  const [InsertDtlUser] = useMutation(INSERT_DTL_USER);

  

  let firmData = null;
  if (data && data.tbl_firm_main) {
    firmData = data.tbl_firm_main[0];
  }
  
  const [firmCode, setFirmCode] = useState(firmData ? firmData.tbl_firm_main.firm_code : "");
  const [firmName, setFirmName] = useState(firmData ? firmData.firm_name : "");
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  const [createUser, setCreateUser] = useState("");
  const [activeTab, setActiveTab] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);

  const [firmMainCode, setFirmMainCode] = useState(firmData ? firmData.firm_code : "");
  const [firmSubCode, setFirmSubCode] = useState("");
  const [firmSubName, setFirmSubName] = useState(firmData ? firmData.firm_sub_name : "");
  const [firmSubType, setFirmSubType] = useState(firmData ? firmData.firm_sub_type : "");
  const [firmSubPlace, setFirmSubPlace] = useState(firmData ? firmData.tbl_firm_sub.place : "");
  const [createSubUser, setCreateSubUser] = useState("");
  const [firmSubActive, setFirmSubActive] = useState("true");
  const [placeSub, setPlaceSub] = useState(1000);

  const [city, setCity] = useState("");
  const [dlang, setDlang] = useState("");

  const [sdpr, setSdpr] = useState("");
  const [dtlLoginUserName, setDtlLoginUserName] = useState("");
  const [dtlUserName, setDtlUserName] = useState("");
  const [dtlUserLastName, setDtlUserLastName] = useState("");
  const [dtlUserDprMainCode, setDtlUserDprMainCode] = useState("");
  const [dtlUserDprSubCode, setDtlUserDprSubCode] = useState("");
  const [dtlUserLang, setDtlUserLang] = useState("");
  const [dtlUserDataLang, setDtlUserDataLang] = useState("");
  const [createDtlUser, setCreateDtlUser] = useState("");
  const [updateDtlUser, setUpdateDtlUser] = useState("");

  

  
  
  



  const [loginUserName, setLoginUserName] = useState("");
  const [loginUserPass, setLoginUserPass] = useState("");





  
  
  

  const [ingredient, setIngredient] = useState('');// checkbox sub firm type

 
  const { users, setUsers } = useContext(UserContext);
  //usernames: userDetails.user_name,

 

  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  useEffect(() => {
    
    if (firmCode !== "000") {
     
      setCreateUser(users.usernames);
      setCreateSubUser(users.usernames);         
      handleinser();  
    
    }
  }, [firmCode, setFirmCode]);

  useEffect(() => {
       if (firmSubCode !=="000") {
           
      handleinsersub();
    }
  }, [firmSubCode, setFirmSubCode]);

 /* useEffect(() => {
    if (firmType =="HTL") {
        
    setTempType("HMDPR");
 }
}, [firmType, setFirmType]);

useEffect(() => {
  if (firmType =="AGN") {
      
  setTempType("AMDPR");
}
}, [firmType, setFirmType]);

useEffect(() => {
  if (firmSubType =="HTL") {
      
  setTempType2("HSDPR");
}
}, [firmSubType, setFirmSubType]);

useEffect(() => {
if (firmSubType =="AGN") {
    
setTempType2("ASDPR");
}
}, [firmSubType, setFirmSubType]); */





useEffect(() => {
  let newTempType = "";

  if (firmType === "HTL") {
    newTempType = "HMDPR";
  } else if (firmType === "AGN") {
    newTempType = "AMDPR";
  }

  setTempType(newTempType);
}, [firmType, firmSubType, setTempType]);

useEffect(() => {
  let newTempType = "";

  if (firmSubType === "HTL") {
    newTempType = "HSDPR";
  } else if (firmSubType === "AGN") {
    newTempType = "ASDPR";
  }

  setTempType2(newTempType);
}, [firmType, firmSubType, setTempType2]);

 useEffect(() => {
    if (tempType =="HSDPR") {
        
      handleInsertTempRecords2();
     
 }

 
}, [tempType, setTempType]);

useEffect(() => {
  if (tempType =="ASDPR") {
      
    handleInsertTempRecords2();
   
}


}, [tempType, setTempType]);

  


  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setFirmCode(updatedIdSeq.toString());  
      setFirmMainCode(updatedIdSeq.toString());  
      
      handleUpdateIdSeq2();
       console.log(firmCode);
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  const handleUpdateIdSeq2 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'SFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setFirmSubCode(updatedIdSeq.toString());        
       console.log(users.usernames);
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  

  


  const handleCloseModal = () => {
    setOpenModal(false);
    
  };


  const handleUpdate = () => {
    updateFirm({
      variables: {
        firmCode: firmData.firm_code,
        firmName: firmName,
        firmType: firmType,
        place: place,
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinser = () => {
    InsertFirm({
      variables: {
        firmCode: firmCode,
        firmName: firmName,
        firmType: firmType,
        place: place, 
        active: "true",
        createUser: users.usernames, 
        updateUser: users.usernames, 
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  const handleinsersub = ()  => {
    InsertSubFirm({
      variables: {
        firmMainCode: firmMainCode,
        firmSubCode :firmSubCode,
        firmSubName : firmSubName,
        firmSubType : firmSubType,
        createSubUser: users.usernames, 
        updateSubUser: users.usernames,        
        active: firmSubActive,
      },
    })
      .then(() => {
        window.alert("Firm Sub insert successfully!");
        handleInsertTempRecords();   
        handleinserLogin();    
        handleinserUserDtl();
       
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  const handleinserLogin = ()  => {
    InsertLoginUser({
      variables: {
        loginUserName: loginUserName,
        loginUserPass :loginUserPass,
        createLoginUser: users.usernames, 
        updateLoginUser: users.usernames,    
       
      },
    })
      .then(() => {
        window.alert("Firm Login User insert successfully!");
            
       
      })
      .catch((error) => {
        console.error("Error insert firm login user:", error);
      });
  };


  const handleinserUserDtl = ()  => {
    InsertDtlUser({
      variables: {
        dtlUserFirmMainCode: firmMainCode,
        dtlUserFirmSubCode :firmSubCode,
        dtlUserFirmType : firmSubType,
        dtlLoginUserName: loginUserName,
        dtlUserName: dtlUserName,
        dtlUserLastName: dtlUserLastName,
        dtlUserDprMainCode: dtlUserDprMainCode,
        dtlUserDprSubCode: dtlUserDprSubCode,
        dtlUserLang : city,
        dtlUserDataLang: dlang,
        createSubUser: users.usernames, 
        updateSubUser: users.usernames,        
       
      },
    })
      .then(() => {
        window.alert("Firm User Dtl insert successfully!");
        handleInsertTempRecords();   
        handleinserLogin();    
       
      })
      .catch((error) => {
        console.error("Error insert firm user dtl:", error);
      });
  };


 
   
  const handleInsertTempRecords = async () => {
    try {    
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = tempData.tbl_temp.map((record) => ({
        firm_main_code: firmMainCode,
        firm_sub_code: firmSubCode,
        lang: "en",
        dpr_main_code: record.temp_code,
        dpr_main_name: record.temp_name,
        dpr_dpr_type: record.temp_type,
        dpr_main_grp_code: record.temp_group,
      }));
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertTempRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_dpr_main.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      if (firmSubType =="AGN") {
      
        setTempType("ASDPR");
      }

      if (firmSubType =="HTL") {
      
        setTempType("HSDPR");
      }
      
        
      console.log("temptype :" ,tempType);  
      
      
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
    }
  };
  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

 


  const  handleInsertTempRecords2 = async () => {
    console.log("calıstı");
    console.log("temptype :" ,tempType);  
    console.log(tempData2.tbl_temp);
    tempData.tbl_temp.forEach((record) => {
      console.log(record);
    });
     
    try {    
      
      
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = tempData2.tbl_temp.map((record) => ({
        firm_main_code: firmMainCode,
        firm_sub_code: firmSubCode,
        lang: "en",
        dpr_main_code: record.opt_2,
        dpr_sub_code: record.temp_code,
        dpr_sub_name: record.temp_name,
        dpr_sub_type: record.temp_type,
        dpr_sub_grp_code: record.temp_group,
      }));

      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertTempRecords2({
        variables: { records: recordsToInsert },
      });

      const affectedRows = insertData.insert_tbl_dpr_sub.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_sub.`);
      console.log(tempData2.tbl_temp);
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_sub:', error);
      console.log("temptype :" ,tempType);  
    }
  };
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  




  


  

  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;


  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-500  dark:bg-black">
      <nav>
      <ul className="flex border-solid mt-3 rounded-md border-b outline-1 ">
        {items.map((item, index) => (
          <li key={index} className={`flex items-center m-1 font-bold ${index === items.length - 1 ? '' : 'font-light'}`}>
            {index !== 0 && <span className="mx-3"> &gt; </span>}
            {item.url ? (
              <Link to={item.url}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </li>
        ))}
      </ul>
    </nav>
   
            <div className="card">
                
                <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
                <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Main Firm
            </span>
          }
          className="ml-5 flex"
        >
                        <p><div className=" p-2 ">
          <h3 className="mb-4 text-lg font-semibold">Create New Firm</h3>

          <div className="card pt-1 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Firm Main Code</label>
    <InputText className="w-full" 
    id="username" value={firmCode} 
    onChange={(e) => setFirmCode(e.target.value)}
    disabled />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Firm Main Name</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} />
  </div>
  </div>

       
    <label htmlFor="firmtype" className=" flex-col my-3 ml-0 mb-5 align-items-center block font-medium text-gray-950">Firm Type </label><p></p>
  
  <div className="flex ml-0 flex-wrap gap-6">
    
      <div className="flex ml-0 align-items-center">
          <RadioButton inputId="ingredient1" name="Hotel" value="HTL" onChange={(e) => setFirmType(e.value)} checked={firmType === 'HTL'} />
          <label htmlFor="ingredient1" className="ml-2">Hotel</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="pizza" value="AGN" onChange={(e) => setFirmType(e.value)} checked={firmType === 'AGN'} />
          <label htmlFor="ingredient2" className="ml-2">Incoming Agency</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient3" name="pizza" value="OPR" onChange={(e) => setFirmType(e.value)} checked={firmType === 'OPR'} />
          <label htmlFor="ingredient3" className="ml-2">Operator</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="pizza" value="SUP" onChange={(e) => setFirmType(e.value)} checked={firmType === 'SUP'} />
          <label htmlFor="ingredient4" className="ml-2">Supplier</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="pizza" value="AIR" onChange={(e) => setFirmType(e.value)} checked={firmType === 'AIR'} />
          <label htmlFor="ingredient5" className="ml-2">Airlines</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="pizza" value="OTA" onChange={(e) => setFirmType(e.value)} checked={firmType === 'OTA'} />
          <label htmlFor="ingredient6" className="ml-2">OTA</label>
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient4" name="pizza" value="SPA" onChange={(e) => setFirmType(e.value)} checked={firmType === 'SPA'} />
          <label htmlFor="ingredient6" className="ml-2">SPA</label>
      </div>
  </div>

  <div className="flex gap-3 my-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">Place</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Time Zone</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>
</div>

</p>
            </Fieldset>
        </div>
             
        </div>          
      </p> 
                   
   </TabPanel>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Sub Firm
            </span>
          }
          className="ml-5 flex"
        >
                        <p> <div className=" p-2 ">
         <h3 className="mb-4 text-lg font-semibold">Create New Sub Firm</h3>

         <div className="mt-4">
         
        </div>
         {/* Firm Main cart  <Fieldset className="my-0 font-thin" legend="Firm Main "> */}
        <div className="card pt-1 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-thin ">
                <div className="flex gap-4">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Firm Main Code</label>
    <InputText className="w-full" 
    id="username" value={firmCode} 
    onChange={(e) => setFirmCode(e.target.value)}
    disabled />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Firm Main Name</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} 
    disabled/>
  </div>
</div>
</p>
            </Fieldset>
        </div>
       {/* Firm Sub cart */}
        <div className="card pt-0 -ml-10 -my-10 ">
            <Fieldset >
                <p className="m-0 pt-0 font-semibold">
                <div className="flex gap-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">Firm Sub Code</label>
    <InputText className="w-full" 
    id="firmsubcode" value={firmSubCode} 
    onChange={(e) => setFirmSubCode(e.target.value)} />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmnsubame">Firm Sub Name</label>
    <InputText className="w-full" 
    id="firmname" value={firmSubName} 
    onChange={(e) => setFirmSubName(e.target.value)} />
  </div>
</div>


<div className="card  flex-col font-medium -ml-5 flex justify-content-center">
<label htmlFor="firmtype" className=" flex-col ml-0 mb-5 align-items-center block font-medium text-gray-950">Firm Type </label><p></p>
  
            <div className="flex ml-0 flex-wrap gap-6">
              
                <div className="flex ml-0 align-items-center">
                    <RadioButton inputId="ingredient1" name="Hotel" value="HTL" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'HTL'} />
                    <label htmlFor="ingredient1" className="ml-2">Hotel</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient2" name="Agency" value="AGN" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'AGN'} />
                    <label htmlFor="ingredient2" className="ml-2">Incoming Agency</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient3" name="Operator" value="OPR" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'OPR'} />
                    <label htmlFor="ingredient3" className="ml-2">Operator</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="Suplayer" value="SUP" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'SUP'} />
                    <label htmlFor="ingredient4" className="ml-2">Supplier</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="Airline" value="AIR" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'AIR'} />
                    <label htmlFor="ingredient5" className="ml-2">Airlines</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="OTA" value="OTA" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'OTA'} />
                    <label htmlFor="ingredient6" className="ml-2">OTA</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="SPA" value="SPA" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'SPA'} />
                    <label htmlFor="ingredient6" className="ml-2">SPA</label>
                </div>
            </div>
            
        </div>

        <div className="flex gap-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Place</label>
    <InputText className="w-full"
     id="firmsubplace" value={firmSubPlace} 
     onChange={(e) => setFirmSubPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Time Zone</label>
    <InputText className="w-full" 
    id="firmname" value={firmSubCode} 
    onChange={(e) => setFirmSubCode(e.target.value)} />
  </div>
</div>
                </p>
            </Fieldset>
        </div>
      
       </div></p>
                    </TabPanel>
                    <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 2 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
             Firm User
            </span>
          }
          className="ml-5 flex"
        >
                        <p> <div className="card pt-0 -ml-10 -my-10 ">
            <Fieldset >
                <p className="m-0 pt-0 font-semibold">
                <div className="flex gap-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4" htmlFor="username">Firm Sub Code</label>
    <InputText className="w-full" 
    id="firmsubcode" value={firmSubCode} 
    onChange={(e) => setFirmSubCode(e.target.value)} 
    disabled/>
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmnsubame">Firm Sub Name</label>
    <InputText className="w-full" 
    id="firmname" value={firmSubName} 
    onChange={(e) => setFirmSubName(e.target.value)}
    disabled/>
  </div>
</div>




        <div className="flex mt-8 gap-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Login User Name</label>
    <InputText className="w-full"
     id="firmsubplace" value={loginUserName} 
     onChange={(e) => setLoginUserName(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Password</label>
    <InputText className="w-full" 
    id="firmname" value={loginUserPass} 
    onChange={(e) => setLoginUserPass(e.target.value)} />
  </div>
  
  <div className="card w-4/6 flex-col font-medium -mt-8 ml-5 flex justify-content-center">
<label htmlFor="firmtype" className=" flex-col ml-0 mb-5 align-items-center block font-medium text-gray-950">User Firm Type </label><p></p>
  
            <div className="flex ml-0 flex-wrap gap-5">
              
                <div className="flex ml-0 align-items-center">
                    <RadioButton inputId="ingredient1" name="Hotel" value="HTL" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'HTL'} />
                    <label htmlFor="ingredient1" className="ml-2">Hotel</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient2" name="Agency" value="AGN" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'AGN'} />
                    <label htmlFor="ingredient2" className="ml-2">Incoming Agency</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient3" name="Operator" value="OPR" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'OPR'} />
                    <label htmlFor="ingredient3" className="ml-2">Operator</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="Suplayer" value="SUP" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'SUP'} />
                    <label htmlFor="ingredient4" className="ml-2">Supplier</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="Airline" value="AIR" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'AIR'} />
                    <label htmlFor="ingredient5" className="ml-2">Airlines</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="OTA" value="OTA" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'OTA'} />
                    <label htmlFor="ingredient6" className="ml-2">OTA</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="ingredient4" name="SPA" value="SPA" onChange={(e) => setFirmSubType(e.value)} checked={firmSubType === 'SPA'} />
                    <label htmlFor="ingredient6" className="ml-2">SPA</label>
                </div>
            </div>
            
        </div>
</div>
<div className="flex mt-8 gap-3">
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Name</label>
    <InputText className="w-full"
     id="firmsubplace" value={dtlUserName} 
     onChange={(e) => setDtlUserName(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Last Name</label>
    <InputText className="w-full" 
    id="firmname" value={dtlUserLastName} 
    onChange={(e) => setDtlUserLastName(e.target.value)} />
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">User Language</label>  
  <Dropdown className="w-full"
  value={city} 
  options={userLangSelectItems} 
  onChange={(e) => setCity(e.value)}
   placeholder="Select a Language"/>
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Data Language</label>  
  <Dropdown  className="w-full"
  value={dlang} 
  options={userLangSelectItems} 
  onChange={(e) => setDlang(e.value)}
   placeholder="Select a Language"/>
  </div>
  </div>
  

  <div className="flex mt-8 gap-3">
  <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Main Department</label>  
  <Dropdown className="w-full"
  value={dtlUserDprMainCode} 
  options={userMdprSelectItems} 
  onChange={(e) => setDtlUserDprMainCode(e.value)}
   placeholder="Select a Department"/>
</div>

  <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Sub Department</label>  
  <Dropdown className="w-full"
  value={dtlUserDprSubCode} 
  options={userSdprSelectItems} 
  onChange={(e) => setDtlUserDprSubCode(e.value)}
   placeholder="Select a Department"/>

</div>
</div>
    </p>
            </Fieldset>
        </div></p>
        <div className="mt-4">
           <button
             className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
             onClick={handleUpdateIdSeq}
           
           >
            Create New Firm
           </button>
           </div>
                    </TabPanel>
                </TabView>
            </div>
      

     

    </div>
 
 
);
};

export default FirmCreateWizard;

/* 
tailwind text field ydk
          <div className="mt-4">
            <label htmlFor="firmCode" className="block font-medium text-gray-700">
              Firm Code
            </label>
            <input
              type="text"
              id="firmCode"
              name="firmCode"
              value={firmCode}
              onChange={(e) => setFirmCode(e.target.value)}
              className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
              
            />
          </div> */

